import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from '../../../utils/UsageTracker';
import { SCREENS } from '../../../constants/Tracking.migrated';
import AcademyOnboardingLandingPage from '../components/AcademyOnboardingLandingPage';
import { HasAcademyOnboardingAccess } from '../../accounts';
import ACForbiddenError from 'academy-common-lib/components/error/ACForbiddenError';
import { jsx as _jsx } from "react/jsx-runtime";
const AcademyOnboarding = () => {
  useEffect(() => {
    UsageTracker.trackStandalone('Pageview', {
      screen: SCREENS.ACADEMY_ONBOARDING
    });
  }, []);
  return /*#__PURE__*/_jsx(HasAcademyOnboardingAccess, {
    fallback: /*#__PURE__*/_jsx(ACForbiddenError, {
      subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.academyOnboarding.forbidden.subtitle"
      })
    }),
    children: /*#__PURE__*/_jsx(AcademyOnboardingLandingPage, {})
  });
};
export default AcademyOnboarding;